import { ReactComponent as ReplaceProductIcon } from '@zonofi/svg-icons/refresh.svg';
import { ReactComponent as SearchIcon } from '@zonofi/svg-icons/search-icon.svg';
import './invoice-item-card.scss';
import { MappingStatus, StatusBadge } from '../status-badge/status-badge';

export interface InvoiceItem {
  id: string;
  name: string;
  price: number;
  quantity: number;
  discount: number;
  totalAmount: number;
  contributionAmount: number;
  appliedScheme: string;
  sku: string;
  hsn: string;
  status: MappingStatus;
}

export const InvoiceItemCard: React.FC<{ item: InvoiceItem }> = ({ item }) => (
  <div className="tiit-item-card">
    <div className="tiit-item-card__header">
      <div className="tiit-item-card__header-left">
        <span className="tiit-item-card__name font-semibold">{item.name}</span>
        <div className="tiit-item-card__price-row font-regular">
          <span>Price: ₹{item.price}</span>
          <span className="tiit-dot" />
          <span>Quantity: {item.quantity}</span>
          <span className="tiit-dot" />
          <span>Discount: {item.discount}%</span>
        </div>
      </div>
      <StatusBadge status={item.status} />
    </div>

    <div className="tiit-item-card__amounts">
      <div className="tiit-item-card__amount-cell padding-left-16">
        <span className="tiit-item-card__amount-label font-semibold">
          {'Total Amount\n(Excl. Tax)'}
        </span>
        <span className="tiit-item-card__amount-value font-semibold">
          ₹{item.totalAmount.toLocaleString('en-IN')}
        </span>
      </div>
      <div className="tiit-item-card__amount-cell">
        <span className="tiit-item-card__amount-label font-semibold">
          {'Contribution\nAmount'}
        </span>
        <span className="tiit-item-card__amount-value tiit-item-card__amount-value--green font-semibold">
          ₹{item.contributionAmount}
        </span>
      </div>
      <div className="tiit-item-card__amount-cell">
        <span className="tiit-item-card__amount-label font-semibold">
          {'Applied\nScheme'}
        </span>
        <span className="tiit-item-card__amount-value font-semibold">
          {item.appliedScheme}
        </span>
      </div>
    </div>

    <div className="tiit-item-card__footer">
      <span className="tiit-item-card__meta font-semibold">
        SKU: {item.sku} &nbsp;•&nbsp; HSN: {item.hsn}
      </span>
      {item.status === 'brand_not_found' ? (
        <button className="tiit-action-link font-regular tiit-action-link--blue">
          <ReplaceProductIcon height={14} width={14} />
          Replace Product
        </button>
      ) : (
        <button className="tiit-action-link font-regular tiit-action-link--blue">
          <SearchIcon height={14} width={14} />
          Find Product
        </button>
      )}
    </div>
  </div>
);
